export const buildGeocodeUrl = (address: string, city: string, state: string, key: string) => {
  const baseUrl = 'https://api.geoapify.com/v1/geocode/search?';
  return `${baseUrl}street=${address}&city=${city}&state=${state}&format=json&apiKey=${key}`;
};

export const fetchData = async (url: string) => {
  const response = await fetch(url);
  return response.json();
};
